import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Injectable } from '@angular/core';
import { IProduct } from '../interfaces/product';
import { BehaviorSubject, Subscription as RxSubscription } from 'rxjs';

import { ProductApiService } from './product-api-service';
@Injectable()
export class ProductDataSource extends DataSource<any> {
  public loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public Product: BehaviorSubject<IProduct[]> = new BehaviorSubject([]);
  public Subscriptions: RxSubscription[] = [];
  public listingId: number;
  constructor(protected ProductApi: ProductApiService) {
    super();
  }

  public async load(listingId) {
    this.loading.next(true);
    this.listingId = listingId;
    await this.ProductApi.list('listing-admin', listingId).then(
      (data: IProduct[]) => {
        this.Product.next(data);
        this.loading.next(false);
      },
      (error) => this.loading.next(false)
    );
  }
  public save(productId: number, Product: IProduct) {
    return this.ProductApi.save(
      'listing-admin',
      productId,
      Product,
      this.listingId
    ).finally(() => this.load(this.listingId));
  }

  public delete(productId: number) {
    return this.ProductApi.delete(
      'listing-admin',
      productId,
      this.listingId
    ).finally(() => this.load(this.listingId));
  }

  public connect(collectionViewer?: CollectionViewer) {
    return this.Product;
  }

  public disconnect(collectionViewer?: CollectionViewer) {
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }
}
